module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/move_1.72a2ce47.png";